<template>
  <div ref="component" class="cx_style" @click.stop>
    <div class="input-wrap">
      <single-input
        ref="fontSizeInput"
        class="percent100"
        :value.sync="valueSync"
        :min="12"
        :max="100"
        inputSuffixs="px"
      />
    </div>
    <el-scrollbar
      class="font-size-ul"
      ref="scrollbar">
      <div
        class="font-size-li"
        v-for="(item, index) in selectOptions"
        :key="index"
        :label="item"
        @click="selectFontSize(item)"
        :value="item">
        <span>{{item}}</span>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [publicData],
  name: "quickFontSize",
  data(){
    return {
      selectOptions:[12,14,16,18,20,24,26,28,32,36,40,42]
    }
  },
  props: {
    tooltipPosition: {
      type: String,
      default: "top"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    visible:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    getSelectStyle() {
      return {
        "--titleSize": this.titleSize
      }
    },
    valueSync: {
      get() {
        return this.value
      },
      set(val) {

        this.$emit("update:value", val)
      }
    },
    visibleSync:{
      get() {
        return this.visible
      },
      set(val) {
        this.$emit("update:visible", val)
      }
    }
  },
  mounted(){
    this.$nextTick(()=>{
      let singleInput = this.$refs.fontSizeInput.$el
      singleInput.getElementsByTagName("input")[0].focus()
    })
  },
  methods: {
    focus() {
      console.log(1, arguments)
    },
    selectFontSize(val){
      this.valueSync = val
      this.visibleSync = false
    }
  }
}
</script>

<style scoped>
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  /* width: 110%; */
  width: calc(100% + 20px);
  height: calc(100% + 20px);
}
.cx_style{
  position: absolute;
  top: 30px;
  left:0;
  width: 88px;
  background-color: #fff;
  border-radius: 4px;
  border:1px solid #E9E9E9;
  box-shadow: 0 6px 24px 0 rgba(31, 35, 41, 0.1);
}
.input-wrap{
  border-bottom: 1px solid rgb(233,233,233);
}
.input-wrap,
.font-size-ul{
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.font-size-ul{
  height: 300px;
  overflow: hidden;
  padding: 0;
}
.font-size-li{
  display: block;
  line-height: 18px;
  padding: 10px 12px;
  width: 100%;
  box-sizing: border-box;
  font-size: 13px;
  color:rgba(0,0,0,0.8);
  text-align: left;
}
.font-size-li:hover{
  background-color: var(--inputBackGround);
}
::v-deep .el-scrollbar__view {
  margin-bottom: 10px;
}
</style>
